export default __webpack_public_path__ + "static/media/premium_image.02c1a8fe.svg";